// ── IMAGE SLOTS (Dental Office Ready) ────────────────────────────────
// Hosted in the Impultienda store resources.
const RES = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/9372a121-9d53-42b9-87d2-9aeda7703ab8/';
const COVER = (id: string) =>
  `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/9372a121-9d53-42b9-87d2-9aeda7703ab8/${id}-mockup.webp?width=720&quality=85&resize=contain`;

/** Box mockup: main product + 5 bonus booklets (transparent background) */
export const heroMockupUrl = RES + '1792531851212_claro-mockup-caja-sin-fondo-c9a50e51.webp';
/** iMac + tablets + phones mockup (transparent background) */
export const offerMockupUrl = RES + '1792531856696_claro-mockup-imac-sin-fondo-f7582228.webp';
/** 6 real pages, in the same order as lookInside.captions */
export const pageImages: string[] = [
  RES + '1792531765996_claro-p01-portada-a1eee83e.webp',
  RES + '1792531770055_claro-p03-sistema-4c884ec7.webp',
  RES + '1792531773818_claro-p08-consent-a69e9cf3.webp',
  RES + '1792531778218_claro-p09-chairside-0e258a02.webp',
  RES + '1792531782082_claro-p10-paciente-d9039b9c.webp',
  RES + '1792531785837_claro-p40-field-card-56bb79d5.webp',
];
/** 5 bonus covers, in the same order as bonuses */
export const bonusCovers: string[] = [
  COVER('e730773d-a59d-41c8-ada4-b005cbdbfcc0'),
  COVER('07101d78-1c67-4952-b232-af8f2fdd2cf1'),
  COVER('adfb0848-e471-4c00-aff1-1c2452ef5471'),
  COVER('fa055a1e-8fe2-4314-a579-358d816d4a20'),
  COVER('860a01b5-e2c9-4647-877b-60f8f2aad8fd'),
];
